export default __webpack_public_path__ + "static/media/certifikat-2021.c4980aba.png";